export const convertFileToBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;

        reader.readAsDataURL(file.rawFile);
    });

export const convertAllToBase64 = (param, then, ...args) => {
    if (param.data?.images === undefined && param.data?.videos === undefined) return then(args);
    else if(param.data?.videos?.length) {
       const newPictures = param.data.videos.filter((p) => p.rawFile instanceof File);
       const formerPictures = param.data.videos
          .filter((p) => !(p.rawFile instanceof File))
          .map((el) => {
             return el.video;
          });
       return Promise.all(newPictures.map(convertFileToBase64)).then((base64Pictures) => {
          param.data.videos = base64Pictures.concat(formerPictures);

       }).then(()=>{
          return then(...args, param)
       });
    }
    else {
        const newPictures = param.data.images.filter((p) => p.rawFile instanceof File);
        const formerPictures = param.data.images
            .filter((p) => !(p.rawFile instanceof File))
            .map((el) => {
                return el.image;
            });
        return Promise.all(newPictures.map(convertFileToBase64)).then((base64Pictures) => {
            param.data.images = base64Pictures.concat(formerPictures);

        }).then(()=>{
            return then(...args, param)
        });
    }
}
